import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import config from '../../../application/config/config';
import Fetch from '../../../core/util/core/Fetch';

import { TabContent, TabPane, Nav, NavItem, NavLink, Col } from 'reactstrap';
import classnames from 'classnames';

import Data from './Tabs/Data.js';
import Contacts from './Tabs/Contacts.js';
import Addresses from './Tabs/Addresses.js';
import BankAccount from './Tabs/BankAccount.js';
import Files from './Tabs/Files.js';

function Edit() {
    const [activeTab, setActiveTab] = useState('data');
    const [isLoading, setIsLoading] = useState(true);
    const [formValues, setFormValues] = useState(null);

    const { id } = useParams();

    const paths = {
        endpointGetById: config.endpoints.backend + 'gci/suppliers/getById'
    };

    useEffect(() => {
        const load = async () => {
            const values = await Fetch.post(paths.endpointGetById, { id });
            setFormValues(values);
            setIsLoading(false);
        };
        load();
    }, []);

    return (
        <div>
            <Nav tabs>
                <NavItem>
                    <NavLink
                        style={{ cursor: 'pointer' }}
                        className={classnames({ active: activeTab === 'data' })}
                        onClick={() => setActiveTab('data')}
                    >
                        Dados
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        style={{ cursor: 'pointer' }}
                        className={classnames({ active: activeTab === 'contacts' })}
                        onClick={() => setActiveTab('contacts')}
                    >
                        Contatos
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        style={{ cursor: 'pointer' }}
                        className={classnames({ active: activeTab === 'addresses' })}
                        onClick={() => setActiveTab('addresses')}
                    >
                        Endereços
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        style={{ cursor: 'pointer' }}
                        className={classnames({ active: activeTab === 'bankAccount' })}
                        onClick={() => setActiveTab('bankAccount')}
                    >
                        Dados Bancários
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        style={{ cursor: 'pointer' }}
                        className={classnames({ active: activeTab === 'files' })}
                        onClick={() => setActiveTab('files')}
                    >
                        Arquivos
                    </NavLink>
                </NavItem>
            </Nav>
            {isLoading ? (
                <p> Carregando.. </p>
            ) : (
                <TabContent activeTab={activeTab} className="bg-white">
                    <TabPane tabId={'data'}>
                        <Col sm="12">
                            <Data formValues={formValues} />
                        </Col>
                    </TabPane>
                    <TabPane tabId={'contacts'}>
                        <Col sm="12">
                            <Contacts formValues={formValues} />
                        </Col>
                    </TabPane>
                    <TabPane tabId={'addresses'}>
                        <Col sm="12">
                            <Addresses formValues={formValues} />
                        </Col>
                    </TabPane>
                    <TabPane tabId={'bankAccount'}>
                        <Col sm="12">
                            <BankAccount formValues={formValues} />
                        </Col>
                    </TabPane>
                    <TabPane tabId={'files'}>
                        <Col sm="12">
                            <Files formValues={formValues} />
                        </Col>
                    </TabPane>
                </TabContent>
            )}
        </div>
    );
}

export default Edit;
